<template>
    <div class="control-room-alert-cell">
        <span v-if="!rowData.active_device_id" class="text-muted">---</span>
        <span v-else-if="!rowData.last_alert_key" class="badge badge-pill badge-light">
            {{ $t('no_alert_reported') }}
        </span>
        <div v-else class="control-room-alert-cell__active">
            <div class="control-room-alert-cell__copy">
                <span class="badge badge-pill badge-danger">{{ rowData.last_alert_label }}</span>
                <small v-if="rowData.last_alert_at" class="text-muted">
                    {{ formatAlertDate(rowData.last_alert_at) }}
                </small>
            </div>
            <button
                type="button"
                class="control-room-alert-cell__clear"
                :disabled="clearing"
                :title="$t('mark_as_false_alert')"
                @click.stop.prevent="clearAlert"
            >
                <app-icon :name="clearing ? 'loader' : 'x'" class="size-14" :class="{ 'rotate-animation': clearing }" />
            </button>
        </div>
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import { TRACKER_ALERT_DISMISS } from '../../../Config/ApiUrl';
import { formatDateToLocal } from '../../../Helpers/Helpers';

export default {
    name: 'ControlRoomAlertCell',
    extends: CoreLibrary,
    props: {
        rowData: {
            type: Object,
            required: true,
        },
        tableId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            clearing: false,
        };
    },
    methods: {
        formatAlertDate(value) {
            return formatDateToLocal(value, true);
        },
        clearAlert() {
            if (!window.confirm(this.$t('confirm_false_tracker_alert'))) {
                return;
            }

            this.clearing = true;
            this.axiosPost({
                url: TRACKER_ALERT_DISMISS,
                data: {
                    trip_id: this.rowData.id,
                    device_id: this.rowData.active_device_id,
                    alert_key: this.rowData.last_alert_key,
                },
            }).then((response) => {
                this.$toastr.s(response.data.message);
                this.$hub.$emit(`reload-${this.tableId}`, false);
            }).catch(({ response }) => {
                this.$toastr.e(response?.data?.message || this.$t('something_went_wrong'));
                this.$hub.$emit(`reload-${this.tableId}`, false);
            }).finally(() => {
                this.clearing = false;
            });
        },
    },
};
</script>

<style scoped>
.control-room-alert-cell__active {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    max-width: 18rem;
}

.control-room-alert-cell__copy {
    display: grid;
    gap: 0.2rem;
    min-width: 0;
}

.control-room-alert-cell__copy .badge {
    max-width: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.control-room-alert-cell__clear {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 1.75rem;
    width: 1.75rem;
    height: 1.75rem;
    padding: 0;
    border: 1px solid rgba(220, 53, 69, 0.25);
    border-radius: 999px;
    color: #dc3545;
    background: rgba(220, 53, 69, 0.08);
}

.control-room-alert-cell__clear:hover {
    background: rgba(220, 53, 69, 0.16);
}

.control-room-alert-cell__clear:disabled {
    cursor: wait;
    opacity: 0.55;
}

.rotate-animation {
    animation: control-room-alert-spin 0.85s linear infinite;
}

@keyframes control-room-alert-spin {
    to { transform: rotate(360deg); }
}
</style>
